import React, { useState, useContext, useEffect } from "react";//FB 7918
import Button from "@material-ui/core/Button";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Business from "@material-ui/icons/Business";
import CalendarToday from "@material-ui/icons/CalendarToday";
import { Grid, Typography } from "@material-ui/core";
import ProviderPage from "../components/Provider";
import FacilityPage from "./location";
import ByDatePage from "./date";
import ByDateTeledermPage from "./date_Telederm";
import { AppointmentType, Context } from "../store";  //FB 8549
import { modify_AppointmentDetails } from "../actions";
import useStyles from "../css/styles";
//FB 8722
import { GetAdminSettingValue, GetAppointmentTypeFromAdmin, GetFacilities, GetProviders, InsertPELogs } from '../api'; //FB 4960 //FB 7918 //FB 8796
import globalsettings from "../../../config"; //FB 4960

// update log
// FB 4371 DK    03/29/2021    Added page for type of appointment module in home page
// FB 4867 DK    01/20/2022    Changed buton label
// FB 4949 DK    02/11/2022    Enable/Disable insurance selection
// FB 4960 BR    07/03/2022    Logging all actions on PE
// FB 6099 GS    07/26/2022    Disable the By Office Location button
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR
// FB 7801 SK    12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time
// FB 7918 SK    01/02/2024    PE - Restrict Appointments as per the Provider's Schedule
// FB 8142 SK    01/23/2024    Sophie - time slots are different when you go with by date vs. by provider flow
// FB 8214 SK    02/01/2024    Accept Case Sensitive Admin Setting Value for Enable PE Custom Appointments in API and Portal and PE
// FB 8796 KI    06/23/2024   Removing provider option if we have only one provider
// FB 8549 DK    10/21/2024    TeleHealth re-work
// FB 8722 DK    11/06/2024    PE workflows enhancements
// FB 9973 DK    01/28/2025    Failed to fetch: GET https://drsamemr.com/api/Provider/GetSlotsByDate

export default function AppointmentFilterPage(props: any) {
  const classes = useStyles();
  const { state, dispatch } = useContext(Context);
  const [appointmentFilter, setAppointmentFilter] = useState(
    state.appointmentdetails.appointmentfilter
  );
  //FB 8796
  const [enableByProviderFilter, setByProvider] = useState(false);
  const [isSingleLocation, setIsSingleLocation] = useState(false);  //FB 8722
  //FB 4371 DK    Added to modify the state when appointment filter is selected
  const handleClick = (selectedFilter: string) => {
    setAppointmentFilter(selectedFilter);
    //FB 4960 Start
    if (selectedFilter == "location") {
      InsertPELogs(globalsettings.clientIp, "Selected by office location");
    }
    else if (selectedFilter == "date") {
      InsertPELogs(globalsettings.clientIp, "Selected by date");
    }
    else if (selectedFilter == "provider") {
      InsertPELogs(globalsettings.clientIp, "Selected by provider");
    }
    //FB 4960 End
    modify_AppointmentDetails(
      {
        appointmenttype: state.appointmentdetails.appointmenttype,
        customappointmenttype: state.appointmentdetails.customappointmenttype,//FB 7801
        patientType: state.appointmentdetails.patientType,
        isInsuranceExist: state.appointmentdetails.isInsuranceExist,
        insurance: {
          id: state.appointmentdetails.insurance.id,
          planId: state.appointmentdetails.insurance.planId,
          name: state.appointmentdetails.insurance.name,
          planName: state.appointmentdetails.insurance.planName,
        },
        appointmentfilter: selectedFilter,
        provider: {
          id: 0,
          name: "",
        },
        location: {
          id: 0,
          name: "",
          address: "",
          region: 0,
        },
        date: new Date(),
      },
      dispatch
    );
    state.region.id = 0;
    state.region.name = "";
    state.region.state = "";
  };

  const handleGoback = () => {
    // FB 4949 DK - Start
    if (props.origin === "PatientType") {
      props.onCallback("");
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Appointment Filter");
      //FB 4960 End
    }
    else {
      props.onCallback("");
      props.insurance({ id: 0, name: "" });
      props.insuranceplan({ id: 0, name: "" });
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Appointment Filter");
      //FB 4960 End 
    }
    // FB 4949 DK - End
  };

  //FB 4371 DK    Added to load the component based on the selected option
  function getcomponent() {
    switch (appointmentFilter) {
      case "provider":
        return <ProviderPage onCallbackType={setAppointmentFilter} />;
        break;

      case "location":
        return <FacilityPage onCallbackType={setAppointmentFilter} />;
        break;

      case "date":
        return state.appointmentdetails.appointmenttype === "telederm" ? (
          <ByDateTeledermPage onCallbackType={setAppointmentFilter} />
        ) : (
          <ByDatePage onCallbackType={setAppointmentFilter} />
        );
        break;

      default:
        break;
    }
  }

  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  //FB 7918 - Begin
  async function fetchAppointmentType() {
    //FB 9973
    const customApptAdmin = (await GetAdminSettingValue("Enable PE Custom Appointments")).toLowerCase();//FB 8214
    sessionStorage.setItem("Enable PE Custom Appointments", customApptAdmin);//FB 8142
    //FB 8214
    if (customApptAdmin == "false") {
      var apptTypes: any = "";
      if (state.appointmentdetails.appointmenttype == "inoffice") {
        if (state.appointmentdetails.patientType == "existing") {
          apptTypes = await GetAppointmentTypeFromAdmin("Existing Patient - Inoffice Appointment");
        }
        else {
          apptTypes = await GetAppointmentTypeFromAdmin("New Patient - Inoffice Appointment");
        }
      }
      else if (state.appointmentdetails.appointmenttype == "telederm") {
        if (state.appointmentdetails.patientType == "existing") {
          apptTypes = await GetAppointmentTypeFromAdmin("Existing Patient - TeleHealth Appointment");
        }
        else {
          apptTypes = await GetAppointmentTypeFromAdmin("New Patient - TeleHealth Appointment");
        }
      }
      sessionStorage.setItem("AppointmentType_N", apptTypes[0].Id); //FB 8549
    }
  }

  //FB 8796 start
  useEffect(() => {
    const fetchProviders = async () => {
      //FB 9973
      //fetchAppointmentType();
      try {
        const data = await GetProviders(0, state.appointmentdetails.appointmenttype);
        if (data.length > 1) {
          setByProvider(true);
        }
      } catch (error) {
        console.error("Error fetching providers:", error);
        setByProvider(false);
      }
    };

    //FB 8722
    const fetchLocations = async () => {
      //FB 9973
      //fetchAppointmentType();
      const data = await GetFacilities(0);
      if (data.length == 1) {
        setIsSingleLocation(true);
      }
    }

    fetchProviders();
    fetchLocations(); //FB 8722
  }, []);
  //FB 8796 end
  //FB 7918 - End

  return (
    <div ref={scrollTo}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography id="chooseMessage" variant="h6">
            Choose how to create an appointment
          </Typography>
        </Grid>
        {/* FB 4867 */}
        <Grid item xs={6} md={4} lg={3}
          style={{
            display:
              //FB 8722
              state.appointmentdetails.appointmenttype === "telederm" ||
                appointmentFilter === "provider" ||
                appointmentFilter === "date"
                ? "none"
                : (globalsettings.isByLocationEnabled && !isSingleLocation ? "inline-flex" : "none"),
          }}
        >
          {/* FB 4867 */}
          <Button
            variant="outlined"
            onClick={() => handleClick("location")}
            startIcon={<Business />}
            className={
              appointmentFilter === "location"
                ? classes.buttonActive
                : classes.buttonInactive
            }
          >
            By Office Location
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          lg={2}
          style={{
            display:
              appointmentFilter === "location" ||
                appointmentFilter === "provider"
                ? "none"
                : "inline-flex",
          }}
        >
          <Button
            variant="outlined"
            id="byDate"
            onClick={() => handleClick("date")}
            startIcon={<CalendarToday />}
            className={
              appointmentFilter === "date"
                ? classes.buttonActive
                : classes.buttonInactive
            }
          >
            By Date
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          md={3}
          lg={2}
          style={{
            display:
              appointmentFilter === "location" || appointmentFilter === "date"
                ? "none"
                //FB 8796
                : (enableByProviderFilter ? "inline-flex" : "none"),
          }}
        >
          <Button
            variant="outlined"
            id="byProvider"
            onClick={() => handleClick("provider")}
            startIcon={<AccountCircle />}
            className={
              appointmentFilter === "provider"
                ? classes.buttonActive
                : classes.buttonInactive
            }
          >
            By Provider
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        className={classes.flexend_Grid}
        style={{
          display: appointmentFilter === "" ? "inline-flex" : "none",
        }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          className={classes.flexend_Grid}
          style={{ marginTop: 10 }}
        >
          <Button
            onClick={handleGoback}
            id="gobackByDate"
            variant="contained"
            className={classes.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
      <React.Fragment>{getcomponent()}</React.Fragment>
    </div>
  );
}
